"use client";

import { Slider } from "@/components/ui/slider";
import {
  setUmrahFilters,
  useUmrahFilter,
} from "@/feature/umrah/package/search/state/extract-umrah-filter-slice";
import { priceFormatter } from "@/lib/price-formatter";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { useEffect, useState } from "react";
import { UmrahAccordion } from "./umrah-accordion";

export function UmrahPriceRangeFilter() {
  const dispatch = useAppDispatch();
  const { selectedOption, defaultOption } = useAppSelector(useUmrahFilter);

  const min = defaultOption.minPrice;
  const max = defaultOption.maxPrice;
  const selectedMin = selectedOption.minPrice ?? min;
  const selectedMax = selectedOption.maxPrice ?? max;

  const [localRange, setLocalRange] = useState<[number, number]>([
    selectedMin,
    selectedMax,
  ]);

  useEffect(() => {
    setLocalRange([selectedMin, selectedMax]);
  }, [selectedMax, selectedMin]);

  if (max <= min) {
    return null;
  }

  return (
    <UmrahAccordion value="price" label="Price Range">
      <Slider
        value={localRange}
        min={min}
        max={max}
        step={1}
        onValueChange={(range) => {
          setLocalRange([range[0], range[1]]);
        }}
        onValueCommit={(range) => {
          dispatch(setUmrahFilters({ minPrice: range[0], maxPrice: range[1] }));
        }}
      />
      <div className="flex justify-between text-xs text-muted-foreground">
        <span>{priceFormatter(localRange[0])}</span>
        <span>{priceFormatter(localRange[1])}</span>
      </div>
    </UmrahAccordion>
  );
}
